import type { Timestamp } from '@bufbuild/protobuf/wkt'

export function formatTimeAgo(timestamp: Timestamp): string {
  const seconds = Number(timestamp.seconds)
  const now = Math.floor(Date.now() / 1000)
  const diff = now - seconds

  if (diff < 60) return 'just now'
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`

  const date = new Date(seconds * 1000)
  return date.toLocaleDateString()
}
